var Backbone = require('backbone');
var _ = require('underscore');

require('./IndexMember.less');


module.exports = Backbone.View.extend({

    el: '.IndexMember',

    events: {
        'click input': 'resetErrorState',
        'change input': 'resetErrorState',
        'focus  input': 'resetErrorState',
        'input input': 'resetErrorState',
        'click .IndexMember-button': 'onSubmitClick',
        'change input[type="radio"]': 'onRadioChange'
    },


    initialize: function () {
    },


    resetErrorState: function (e) {
        $(e.currentTarget)
            .closest('.IndexMember-inputLine')
            .removeClass('IndexMember-inputLine--error IndexMember-inputLine--error-with-input');
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    show: function (params) {
        this.$el.addClass('visible');

        this.$('h2 span').text(params.memberName);
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    checkRequired: function (params) {
        var hasError = false;
        var self = this;

        //check form inputs
        this.$('.IndexMember-inputName--required').each(function (ind, item) {
            if (hasError) return;

            var $wrapper = $(item).closest('.IndexMember-inputLine');
            var $input = $('input', $wrapper).eq(0);
            var inputName = $input.attr('name');
            var inputType = $input.attr('type');

            if (inputType == 'radio') {
                var val = self.$('input[name="' + inputName + '"]:checked').val();

                if (val == undefined) {
                    $wrapper.addClass('IndexMember-inputLine--error');
                    hasError = true;

                    return;
                }
            } else {
                var val = $.trim($input.val());

                if (!val) {
                    params.focusOnError && $input.focus();
                    $wrapper.addClass('IndexMember-inputLine--error-with-input');
                    hasError = true;

                    return;
                }
            }
        });

        return !hasError;
    },


    getFormData: function () {
        var data = {
            'NameOfShow':  this.$('input[name="NameOfShow"]').val(),
            'ProductionCompany': this.$('input[name="ProductionCompany"]').val(),
            'Position': this.$('input[name="Position"]').val(),
            'IsUnion': this.$('input[name="IsUnion"]:checked').val()
        };

        console.log(data);

        return data;
    },


    onSubmitClick: function () {
        if (!this.checkRequired({focusOnError: true})) return;

        var data = this.getFormData();

        this.trigger('submit', data);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/components/IndexMember/IndexMember.js
// module id = 18
// module chunks = 0